import React from 'react';
import './ThemedText.less';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'body'
  | 'bodySmall'
  | 'caption'
  | 'button'
  | 'subtitle'
  | 'note';

export type FontWeight = 'regular' | 'medium' | 'semiBold' | 'bold';

export type ColorVariant =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'default'
  | 'gray'
  | 'lightGray'
  | 'darkGray'
  | 'success'
  | 'danger'
  | 'warning'
  | 'positive'
  | 'white';

interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  variant?: TypographyVariant;
  fontWeight?: FontWeight;
  color?: ColorVariant;
  hexColor?: string;
  align?: 'left' | 'center' | 'right' | 'justify';
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  underline?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
}

const ThemedText = ({
  as,
  variant = 'body',
  fontWeight = 'regular',
  color = 'default',
  hexColor,
  align,
  children,
  className,
  style,
  underline,
  onClick,
}: TypographyProps) => {
  const tag =
    as ||
    (variant.startsWith('h')
      ? (variant as keyof JSX.IntrinsicElements)
      : variant === 'body'
      ? 'p'
      : 'span');

  const classes = className
    ? className
    : `typo ` + `typo-${variant} ` + `typo-${fontWeight} ` + `typo-${color} `;

  return React.createElement(
    tag,
    {
      className: classes.trim(),
      style: {
        ...(hexColor && { color: hexColor }),
        ...(align && { textAlign: align }),
        ...style,
        ...(underline && { textDecoration: 'underline' }),
      },
      onClick,
    },
    children || null
  );
};

export default ThemedText;
